export class UrlBuilder {
  parameters = [];

  constructor(base) {
    this.base = base;
  }

  add(name, value) {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        this.parameters.push({ name, value });
      }
    } else if (value) {
      this.parameters.push({ name, value });
    } else if (value === 0) {
      this.parameters.push({ name, value });
    }

    return this;
  }

  _renderArray(name, values) {
    let isFirst = true;
    let result = '';

    for (const value of values) {
      if (isFirst) {
        result = `${name}=${value}`;
        isFirst = false;
      } else {
        result = `${result}&${name}=${value}`;
      }
    }

    return result;
  }

  _renderParameter(name, value) {
    if (Array.isArray(value)) {
      return this._renderArray(name, value);
    } else {
      return `${name}=${value}`;
    }
  }

  toString() {
    let url = this.base;
    let isFirst = true;

    for (const parameter of this.parameters) {
      if (isFirst) {
        url = `${url}?${this._renderParameter(parameter.name, parameter.value)}`;
        isFirst = false;
      } else {
        url = `${url}&${this._renderParameter(parameter.name, parameter.value)}`;
      }
    }

    return url;
  }
}
